module.exports = __webpack_public_path__ + "assets-cabinet/img/transfers-icon.088bd07e.svg";